import Image from 'next/future/image';
import Link from 'next/link';
import plus_black from '@/public/icons/homepage/plus.svg';

const ViewAll = ({ link, title }: { link: string; title: string }) => (
  <div className="h-full w-full rounded-md bg-teal-500 p-5 text-gray-700">
    <Link href={link} passHref>
      <a className="flex h-full w-full flex-col items-center justify-center duration-500 ease-in-out will-change-contents hover:scale-105">
        <div className="block h-6 w-6 xs:h-7 xs:w-7">
          <Image src={plus_black} alt={title} className="w-full" />
        </div>
        <p className="mt-4 max-w-[75%] text-center text-xs font-bold !leading-4 xxs:text-sm xs:!leading-5 sm:text-base">
          All {title}
        </p>
      </a>
    </Link>
  </div>
);

export default ViewAll;
